import { isEmpty } from "lodash";
import { useAppSelector } from "redux/hooks";
import Pencil from "./pencil.png";
import PencilFilled from "./pencil_filled.png";

export const CustomContentIcon = (props: any) => {
  const selectedMyPlanDetail: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);

  const checkIfChildIsCustomized = () => {
    switch (props.type) {
      case "plan":
        return (
          selectedMyPlanDetail?.sections?.some(
            (section: any) =>
              section?.isSectionCustomized || section?.cards?.some((card: any) => card?.isCardCustomized)
          ) ?? false
        );
      case "section":
        return !isEmpty(props.data.cards?.find((item: any) => item.isCardCustomized));
      default:
        return false;
    }
  };

  return props.isCustom || checkIfChildIsCustomized() ? (
    <div>
      <img
        src={props.isCustom ? PencilFilled : Pencil}
        alt="sample"
        height="18"
        width="18"
        style={{ marginTop: "8px", marginBottom: "8px", marginRight: "10px" }}
      />
    </div>
  ) : (
    <></>
  );
};
